import { H3TileLayer } from '@deck.gl/carto'
import { GeoJsonLayer, GeoJsonLayerProps } from '@deck.gl/layers'
import {
  LAYER_HIGHLIGHT_FILL_COLOR_HOVER,
  LAYER_HIGHLIGHT_FILL_COLOR_PRIMARY,
  LAYER_HIGHLIGHT_LINE_COLOR_PRIMARY,
  LAYER_HIGHLIGHT_LINE_WIDTH_MEDIUM
} from './constants'
import { getDatasetType, getSchemeFromTilesetDataset } from 'features/builder/state/builderSliceUtils'
import { KeplerTable, LayerTypes, TilingScheme } from 'features/builder/types'
import { MapType } from 'features/maps/types'
import IconH3 from 'assets/icons/layers/hexagonId.svg?react'
import SpatialIndexLayer from './SpatialIndexLayer'

export default class H3Layer extends SpatialIndexLayer {
  public get type() {
    return LayerTypes.H3
  }

  get name() {
    return 'H3'
  }

  get layerIcon() {
    return IconH3
  }

  static findDefaultLayerProps(dataset: KeplerTable, foundLayers) {
    const emptyProps = { props: [] }

    if (foundLayers?.length) {
      return emptyProps
    }
    const scheme = getSchemeFromTilesetDataset(dataset)

    if (getDatasetType(dataset) === MapType.tileset && scheme === TilingScheme.H3) {
      return {
        props: [
          {
            label: dataset.label,
            isVisible: true,
            columns: {}
          }
        ]
      }
    }
    return emptyProps
  }

  renderLayer(opts: unknown) {
    // @ts-expect-error Types missing in Kepler.
    if (!opts?.data?.data) return []

    const { highlightGeometry, highlightGeometryStyle } = this.config
    const renderProps = this.getRenderProps(opts)

    let highlightLayerProps: Partial<GeoJsonLayerProps>
    if (highlightGeometryStyle === 'hover') {
      highlightLayerProps = {
        getFillColor: LAYER_HIGHLIGHT_FILL_COLOR_HOVER
      }
    } else {
      highlightLayerProps = {
        getFillColor: LAYER_HIGHLIGHT_FILL_COLOR_PRIMARY,
        getLineWidth: LAYER_HIGHLIGHT_LINE_WIDTH_MEDIUM,
        getLineColor: LAYER_HIGHLIGHT_LINE_COLOR_PRIMARY
      }
    }

    return [
      new H3TileLayer(this.getRenderProps(opts)),
      new GeoJsonLayer({
        ...renderProps,
        id: `highlight-${renderProps.id}`,
        data: highlightGeometry,
        ...highlightLayerProps,
        lineWidthUnits: 'pixels',
        lineWidthScale: 1
      })
    ]
  }
}
